module.exports = __webpack_public_path__ + "static/img/ReportFormsTabber.7d36bde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ReportFormsTabber.jpg
// module id = Gzus
// module chunks = 1